export default __webpack_public_path__ + "static/multi-cloud-1-0986040d8ae732ddec15ed99f007b4bc.png";